import { Controller } from "@hotwired/stimulus"
import { Chart } from 'chart.js/auto'

export default class extends Controller {
  connect() {
    this.fetchData()
  }

  async fetchData() {
    try {
      const response = await fetch('/api/billing/employee_summary')
      const data = await response.json()
      this.initializeChart(data)
    } catch (error) {
      console.error('Error fetching employee billing data:', error)
    }
  }

  initializeChart(data) {
    const ctx = this.element.getContext('2d')
    
    new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data.labels,
        datasets: [{
          label: 'Employee Billing',
          data: data.values,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          borderRadius: 4,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            grid: {
              display: false,
              drawBorder: false
            },
            ticks: {
              color: 'rgba(255, 255, 255, 0.8)'
            }
          },
          y: {
            grid: {
              color: 'rgba(255, 255, 255, 0.1)',
              drawBorder: false
            },
            ticks: {
              color: 'rgba(255, 255, 255, 0.8)',
              callback: (value) => `$${value}`
            }
          }
        }
      }
    })
  }

  disconnect() {
    // Clean up chart if needed
  }
} 